/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWochenplanDto } from '../../models/create-wochenplan-dto';
import { WochenplanDto } from '../../models/wochenplan-dto';

export interface CreateOneWochenplan$Plain$Params {
      body?: CreateWochenplanDto
}

export function createOneWochenplan$Plain(http: HttpClient, rootUrl: string, params?: CreateOneWochenplan$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<WochenplanDto>> {
  const rb = new RequestBuilder(rootUrl, createOneWochenplan$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WochenplanDto>;
    })
  );
}

createOneWochenplan$Plain.PATH = '/v1/wochenplaene';
